// this is for prevnext links added in tinyMCE and for project arrows

import { utility_controller } from '../utility/utility_controller'

var sameCatIdToUseSetByThumbnailGrid = null

var prevnext_controller = {
	getProjectLinkAttrs: function (nextprev) {
		return getProjectLinkAttrs(nextprev)
	},
	// getCatId: function (postid) {
	// 	return getCatId(postid)
	// },
	getCatLength: function (catid) {
		return getCatLength(catid)
	},
	showHideProjectArrows: function (state) {
		showHideProjectArrows(state)
	},
	maybeHideProjectArrowsOnInit: function () {
		maybeHideProjectArrowsOnInit()
	},
	useCatIdForSameCategoryPrevNext: function (catId) {
		sameCatIdToUseSetByThumbnailGrid = catId
		sessionStorage.setItem('sameCatIdToUseSetByThumbnailGrid', catId)
	},
	i: function () {
		i()
	},
}

export default prevnext_controller

var stateMap = {
	id: null,
	catid: null,
	type: null,
	projectsMeta: [],
}

var jqueryMap = {
	$pa_next: null,
	$pa_prev: null,
	$body: null,
}

var setStateMap = function () {
	stateMap.catid = utility_controller.parseIdsString(jqueryMap.$body.attr('data-catid'))
	stateMap.id = jqueryMap.$body.attr('data-id')
	stateMap.type = jqueryMap.$body.attr('data-type')
}

var updatePrevNextLinksAddedWithTinyMCE = function ($parent) {
	if ($parent == undefined) {
		$parent = jQuery('body')
	}
	// using body "data-type" attr here instead of checking history state, because document ready can be called before history has initialized on slower connections
	if (jQuery('body').attr('data-type') == 'project') {
		$parent.find('a[href="#laynextproject"], a.laynextproject').each(function () {
			var obj = getProjectLinkObj('next')
			if (typeof obj != 'undefined') {
				jQuery(this).attr({
					'data-type': 'project',
					href: obj.url,
					'data-catid': utility_controller.stringifyCatIds(obj.catid),
					'data-id': obj.id,
					'data-title': obj.title,
				})
				var text = jQuery(this).text()
				if (text.includes('$nextprojecttitle$')) {
					var newText = text.replace('$nextprojecttitle$', obj.title)
					jQuery(this).text(newText)
				}
			}
		})

		$parent.find('a[href="#layprevproject"], a.layprevproject').each(function () {
			var obj = getProjectLinkObj('prev')
			if (typeof obj != 'undefined') {
				jQuery(this).attr({
					'data-type': 'project',
					href: obj.url,
					'data-catid': utility_controller.stringifyCatIds(obj.catid),
					'data-id': obj.id,
					'data-title': obj.title,
				})
				var text = jQuery(this).text()
				if (text.includes('$previousprojecttitle$')) {
					var newText = text.replace('$previousprojecttitle$', obj.title)
					jQuery(this).text(newText)
				}
			}
		})
	}
}
// for marquee lazyloadable js
window.updatePrevNextLinksAddedWithTinyMCE = updatePrevNextLinksAddedWithTinyMCE

var maybeHideProjectArrowsOnInit = function () {
	var type = jQuery('body').attr('data-type')
	//hide project arrows if only 1 project is in category
	if (type == 'project' && layData.show_arrows == 'on') {
		var catlength = getCatLength(utility_controller.parseIdsString(jQuery('body').attr('data-catid')))
		if (catlength <= 1) {
			jQuery('.project-arrow').addClass('hide')
		}
	}
	// hide project arrows if curr page is not project
	if (type != 'project') {
		jQuery('.project-arrow').addClass('hide')
	}
}

var showHideProjectArrows = function () {
	if (layData.show_arrows == 'on') {
		var type = jQuery('body').attr('data-type')
		if (type != 'project') {
			jQuery('.project-arrow').addClass('hide')
		}
		if (type == 'project') {
			//hide project arrows if only 1 project is in category
			var catlength = getCatLength(utility_controller.parseIdsString(jQuery('body').attr('data-catid')))
			if (catlength <= 1) {
				jQuery('.project-arrow').addClass('hide')
			} else if (layData.pa_type != 'project-thumbnails') {
				jQuery('.project-arrow').removeClass('hide')
			}
		}
		// for thumbnails as arrows hide them and show them again, when loaded in layout controller
		if (type == 'project' && layData.pa_type == 'project-thumbnails') {
			jQuery('.project-arrow').addClass('hide')
		}
	}
}

var getProjectIndex = function (nextprev) {
	switch (layData.prevnext_navigate_through) {
		case 'same_category':
			var ix, i
			var currentId = stateMap.id
			var currentCatId = sameCatIdToUse

			if (typeof stateMap.projectsMeta[currentCatId] == 'undefined') {
				return 0
			}
			var length = stateMap.projectsMeta[currentCatId].length

			for (i = 0; i < length; i++) {
				if (currentId == stateMap.projectsMeta[currentCatId][i]['id']) {
					ix = i
					break
				}
			}

			if (nextprev == 'next') {
				ix++
				if (ix == length) {
					ix = 0
				}
			} else if (nextprev == 'prev') {
				ix--
				if (ix < 0) {
					ix = length - 1
				}
			}

			return ix
			break
		case 'all_projects':
			// projectsmeta is not indexed by category ids when prevnext goes through all projects
			var ix, i
			var currentId = stateMap.id
			var length = stateMap.projectsMeta.length

			for (i = 0; i < length; i++) {
				if (currentId == stateMap.projectsMeta[i]['id']) {
					ix = i
					break
				}
			}

			if (nextprev == 'next') {
				ix++
				if (ix == length) {
					ix = 0
				}
			} else if (nextprev == 'prev') {
				ix--
				if (ix < 0) {
					ix = length - 1
				}
			}
			return ix
			break
	}
}

var getProjectLinkAttrs = function (nextprev) {
	// legacy code for backwards compatibility. used to add next, prev projectlinks via contextmenu
	// now it's addable directly in tinymce	var obj = getProjectLinkObj(nextprev);
	if (typeof obj != 'undefined') {
		return 'href="' + obj.url + '" data-catid="' + obj.catid + '" data-id="' + obj.id + '" data-title="' + obj.title + '" data-type="project"'
	}
}

var getProjectLinkObj = function (nextprev) {
	var ix = getProjectIndex(nextprev)
	if (jQuery.isNumeric(ix)) {
		switch (layData.prevnext_navigate_through) {
			case 'same_category':
				var currentCatId = sameCatIdToUse

				if (typeof currentCatId != 'undefined') {
					return {
						title: stateMap.projectsMeta[currentCatId][ix]['title'],
						url: stateMap.projectsMeta[currentCatId][ix]['url'],
						id: stateMap.projectsMeta[currentCatId][ix]['id'],
						catid: stateMap.projectsMeta[currentCatId][ix]['catid'],
						thumb: stateMap.projectsMeta[currentCatId][ix]['thumb'],
						thumbar: stateMap.projectsMeta[currentCatId][ix]['thumbar'],
					}
				}
				break
			case 'all_projects':
				return {
					title: stateMap.projectsMeta[ix]['title'],
					url: stateMap.projectsMeta[ix]['url'],
					id: stateMap.projectsMeta[ix]['id'],
					catid: stateMap.projectsMeta[ix]['catid'],
					thumb: stateMap.projectsMeta[ix]['thumb'],
					thumbar: stateMap.projectsMeta[ix]['thumbar'],
				}
				break
		}
	}
}

var getLazyImg = function () {}

var updateArrows = function () {
	// project arrows (project prev, next links)
	if (layData.show_arrows == 'on' && jqueryMap.$body.attr('data-type') == 'project') {
		var nextAttrs = getProjectLinkObj('next')
		var prevAttrs = getProjectLinkObj('prev')

		if (typeof nextAttrs != 'undefined') {
			jqueryMap.$pa_next.attr({
				'data-title': nextAttrs.title,
				'data-catid': utility_controller.stringifyCatIds(nextAttrs.catid),
				'data-id': nextAttrs.id,
				href: nextAttrs.url,
			})

			var text = jqueryMap.$pa_next.attr('data-original-text') == undefined ? jqueryMap.$pa_next.text() : jqueryMap.$pa_next.attr('data-original-text')
			if (text.includes('$nextprojecttitle$')) {
				if (jqueryMap.$pa_next.attr('data-original-text') == undefined) {
					jqueryMap.$pa_next.attr('data-original-text', text)
				}
				var newText = text.replace('$nextprojecttitle$', nextAttrs.title)
				jqueryMap.$pa_next.text(newText)
			}
		}

		if (typeof prevAttrs != 'undefined') {
			jqueryMap.$pa_prev.attr({
				'data-title': prevAttrs.title,
				'data-catid': utility_controller.stringifyCatIds(prevAttrs.catid),
				'data-id': prevAttrs.id,
				href: prevAttrs.url,
			})
			var text = jqueryMap.$pa_prev.attr('data-original-text') == undefined ? jqueryMap.$pa_prev.text() : jqueryMap.$pa_prev.attr('data-original-text')
			if (text.includes('$previousprojecttitle$')) {
				if (jqueryMap.$pa_prev.attr('data-original-text') == undefined) {
					jqueryMap.$pa_prev.attr('data-original-text', text)
				}
				var newText = text.replace('$previousprojecttitle$', prevAttrs.title)
				jqueryMap.$pa_prev.text(newText)
			}
		}

		if (layData.pa_type == 'project-thumbnails') {
			if (typeof nextAttrs != 'undefined') {
				var nextImg = '<img src="' + nextAttrs.thumb['_512'] + '" alt="">'
				jqueryMap.$pa_next.html('<div class="pa-thumb-wrap" style="padding-bottom:' + nextAttrs.thumbar * 100 + '%;">' + nextImg + '</div>')
			}

			if (typeof prevAttrs != 'undefined') {
				var prevImg = '<img src="' + prevAttrs.thumb['_512'] + '" alt="">'
				jqueryMap.$pa_prev.html('<div class="pa-thumb-wrap" style="padding-bottom:' + prevAttrs.thumbar * 100 + '%;">' + prevImg + '</div>')
			}

			if (layData.prevnext_navigate_through == 'same_category') {
				var catlength = getCatLength(sameCatIdToUse)
				if (catlength > 1) {
					jqueryMap.$pa_next.removeClass('hide')
					jqueryMap.$pa_prev.removeClass('hide')
				}
			} else {
				jqueryMap.$pa_next.removeClass('hide')
				jqueryMap.$pa_prev.removeClass('hide')
			}
		}
	}
}

var getCatLength = function (catid) {
	if (typeof catid != 'undefined' && catid != '') {
		if (layData.prevnext_navigate_through == 'same_category') {
			var catid_to_go_through = sameCatIdToUse
			// var catid_to_go_through = getCurrentCatIdThatIsNotDefaultCat(catid)
			return stateMap.projectsMeta[catid_to_go_through].length
		} else {
			return stateMap.projectsMeta.length
		}
	}
}

// var getCatId = function (postid) {
// 	var catids = []

// 	switch (layData.prevnext_navigate_through) {
// 		case 'same_category':
// 			for (var prop in stateMap.projectsMeta) {
// 				for (var i = 0; i < stateMap.projectsMeta[prop].length; i++) {
// 					if (stateMap.projectsMeta[prop][i]['id'] == postid) {
// 						catids.push(prop)
// 					}
// 				}
// 			}
// 			break
// 		case 'all_projects':
// 			for (var i = 0; i < stateMap.projectsMeta.length; i++) {
// 				if (postid == stateMap.projectsMeta[i]['id']) {
// 					catids.push(stateMap.projectsMeta[i]['catid'])
// 				}
// 			}
// 			break
// 	}
// 	return catids
// }

// var getCurrentCatId = function (currentCatIds) {
// 	if (Array.isArray(currentCatIds)) {
// 		return currentCatIds[0]
// 	}
// 	return currentCatIds
// }

var getCurrentCatIdThatIsNotDefaultCat = function (currentCatIds) {
	if (Array.isArray(currentCatIds)) {
		for (var i = 0; i < currentCatIds.length; i++) {
			if (currentCatIds[i] != parseInt(layData.default_category_id, 10)) {
				return currentCatIds[i]
			}
		}
		return currentCatIds[0]
	}
	return currentCatIds
}

var setjqueryMap = function () {
	jqueryMap.$pa_next = jQuery('.pa-next')
	jqueryMap.$pa_prev = jQuery('.pa-prev')
	jqueryMap.$body = jQuery('body')
}

var previousPageType = null
var sameCatIdToUse = null

var i = function () {
	setjqueryMap()
	stateMap.projectsMeta = JSON.parse(layData.projectsMeta)

	window.laytheme.on('newpageshown', function (obj, type, obj2) {
		// determine which category to use for prevnext links when we navigate through same category
		if (layData.prevnext_navigate_through == 'same_category') {
			if (type == 'project' && previousPageType != 'project') {
				// we just came from a page to a project. we determine the category we want to use as the "same-category" for the prevnext links.
				// if we only have one category, thats easy then we use this one.
				// if we have multiple categories, we use the category that is not the default category.

				let sameCatIdToUseStored = sessionStorage.getItem('sameCatIdToUse')

				if (sameCatIdToUseStored == null || sameCatIdToUseStored == 'null') {
					var catids = utility_controller.parseIdsString(jqueryMap.$body.attr('data-catid'))
					sameCatIdToUse = getCurrentCatIdThatIsNotDefaultCat(catids)
					if (sessionStorage.getItem('sameCatIdToUseSetByThumbnailGrid') != null && sessionStorage.getItem('sameCatIdToUseSetByThumbnailGrid') != 'null') {
						sameCatIdToUse = sessionStorage.getItem('sameCatIdToUseSetByThumbnailGrid')
					}
					// set it to null so we dont use it again:
					sameCatIdToUseSetByThumbnailGrid = null
					sessionStorage.removeItem('sameCatIdToUseSetByThumbnailGrid')
					sessionStorage.setItem('sameCatIdToUse', sameCatIdToUse)
				} else {
					sameCatIdToUse = sameCatIdToUseStored
				}

				// if we came from a filtered thumbnailgrid, we use the category of the filtered thumbnailgrid.
			} else {
			}
			previousPageType = type
		}

		let currentCatIds = utility_controller.parseIdsString(jQuery('body').attr('data-catid'))
		if (currentCatIds.length > 0) {
			let temp = parseInt(sameCatIdToUse, 10)
			let currentCatIdsAsInts = currentCatIds
				.map(function (catId) {
					return parseInt(catId, 10)
				})
				.filter(function (catId) {
					return jQuery.isNumeric(catId)
				})

			if (!jQuery.isNumeric(temp)) {
				sameCatIdToUse = currentCatIds[0]
			} else if (currentCatIdsAsInts.indexOf(temp) === -1) {
				// Fallback when stored category context does not match this project anymore
				// (e.g. filtered grid context or stale session value).
				sameCatIdToUse = currentCatIds[0]
			}
		}

		// if for some reason, the "sameCatIdToUse" is not part of any of the categories of the current page, we set it to the first category

		showHideProjectArrows()
		setStateMap()
		updateArrows()
		updatePrevNextLinksAddedWithTinyMCE()
		maybeHideProjectArrowsOnInit()
	})
}

export { updatePrevNextLinksAddedWithTinyMCE }
